<template>
  <div
    class="park-page"
    @touchstart="touchStart"
    @touchmove="touchMove"
  >
    <!-- 点位图 -->
    <!-- <drop-pos
      v-if="pointInfo"
      class="drop-pos fade-ani"
      :view="selectAccord"
      :cp-src="require('@/imgs/tour/cp_c.png')"
      :off-rotate="offRotate"
      :point-info="pointInfo"
      @viewChange="onChangeAccord"
    /> -->
    <div
      id="vtourSand"
      class="vtour-view"
    />
    <!-- 滑动器 -->
    <accord-menu
      class="menu-view"
      :tag-info="TAG_INFO"
      :info="accordInfo"
      :value="selectAccord"
      :group="group"
      @onChange="onChangeAccord"
      @onChangeGroup="onChangeGroup"
    />
  </div>
</template>

<script>
import DropPos from '@/components/DropPos';
import AccordMenu from '@/components/index/AccordMenu';
import { ACCORD_INFO_03, POINT_INFO_03, HOUSE_TAG_INFO } from '@/libs/config/tour';

export default {
  components: {
    AccordMenu,
    DropPos,
  },
  props: {
    version: {
      type: String,
      default: 'v0',
    },
  },
  data() {
    return {
      showGroup: true,
      selectAccord: ACCORD_INFO_03[0].id,
      accordInfo: ACCORD_INFO_03,
      pointInfo: POINT_INFO_03,
      offRotate: 0,
      isDefaultStyle: true, // 默认风格
      group: 3,
      TAG_INFO: HOUSE_TAG_INFO,
    };
  },
  mounted() {
    window.embedpano({
      // swf: 'https://outsourcing.obs.cn-south-1.myhuaweicloud.com/xukebao/vanke/vtour_78/tour.swf',
      // xml: `https://outsourcing.obs.cn-south-1.myhuaweicloud.com/xukebao/vanke/vtour_78/tour.xml?v=${this.version}`,
      xml: './vtour_03/tour.xml',
      swf: './vtour_03/tour.swf',
      target: 'vtourSand', // DOM节点id
      id: 'sand',
      html5: 'only',
      onready: this.krpano_onready_callback,
    });
    this.si = setInterval(() => {
      if (this.krpano) {
        const sceneName = this.krpano.get('xml.scene');
        if (!sceneName) {
          return;
        }
        const num = sceneName.replace(/[^\d.]/g, '');
        if (num === '10') return;
        if (num === this.selectAccord) {
          return;
        }
        this.onChangeAccord(num);
      }
    }, 500);
  },
  destroyed() {
    if (this.si) {
      clearInterval(this.si);
    }
  },
  methods: {
    onChangeGroup(group) {
      this.$router.push({ path: group });
    },
    onChangeStyle() {
      const { isDefaultStyle } = this;
      if (isDefaultStyle) {
        this.krpano.call('loadscene(\'scene_10\', null, null, BLEND(1))');
      } else {
        this.krpano.call('loadscene(\'scene_03\', null, null, BLEND(1))');
      }
      this.isDefaultStyle = !isDefaultStyle;
    },
    krpano_onready_callback(krpanoInterface) {
      this.krpano = krpanoInterface;
    },
    onChangeAccord(id) {
      this.offRotate = 0;
      this.selectAccord = id;
      this.krpano.call(`loadscene('scene_${id}', null, null, BLEND(1))`);
    },
    touchStart() {
      this.startX = this.krpano.get('view.hlookat');
    },

    touchMove() {
      const endX = this.krpano.get('view.hlookat');
      this.offRotate += endX - this.startX;
      this.startX = endX;
    },
  },
};
</script>

<style lang="less" scoped>
.park-page {
  width: 10rem;
  height: calc(100vh - 54px);
  .drop-pos {
    position: absolute;
    z-index: 20;
    left: .2rem;
    top: 30px;
    width: 180px;
  }
  .compass {
    position: absolute;
    z-index: 11;
    right: 0.5rem;
    bottom: calc(4vh + 60px);
  }
  .disclaimer {
    position: absolute;
    z-index: 100;
    right: 0.5rem;
    bottom: calc(10vh + 60px);
  }
  .menu-view {
    position: absolute;
    z-index: 11;
    left: 0;
    bottom: 54px;
  }
  .tag-view {
    position: absolute;
    z-index: 11;
    left: 0;
    // bottom: calc(20vh + 60px);
    top: calc(65vh - 60px);
    animation: fade-ani 1s linear;
    .tag {
      min-width: 71px;
      height: 24px;
      margin-bottom: 5px;
      padding: 0 5px 1px 2px;
      box-sizing: border-box;
      background: #000000;
      opacity: 0.72;
      font-size: 10px;
      font-weight: normal;
      color: #e6e6e6;
      border-radius: 0px 10px 10px 0px;
      border: 0.5px solid #cda36e;
    }
    .select-tag {
      opacity: 1;
      color: #000000;
      background: rgba(205, 163, 110, 0.9);
      border: 0.5px solid #edc28b;
    }
  }
}
</style>
